import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex font-montserrat flex-col justify-center items-center" }
const _hoisted_2 = {
  key: 0,
  class: "bg-green-600 border border-green-600 my-[10px] z-[1000000000000] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_3 = {
  key: 1,
  class: "bg-red-600 border border-red-600 my-[10px] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-[1000000000000] rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "md:h-[80px] h-[50px]" }, null, -1)
const _hoisted_6 = { class: "absolute z-[1000000] text-left bg-black/50 px-[20px] md:px-[50px] text-white top-0 left-0 right-0 bottom-0 w-full flex items-center flex-col justify-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "md:my-[50px] my-[20px]" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl md:text-6xl font-bold uppercase text-center opacity-100" }, "Articles")
], -1)
const _hoisted_8 = ["onSubmit"]
const _hoisted_9 = { class: "flex flex-col items-end justify-center" }
const _hoisted_10 = { class: "border-r-4 max-w-[420px] md:mb-[20px] mb-[10px] md:text-xl text-sm border-cyan-500 text-right px-1" }
const _hoisted_11 = { class: "flex items-end h-full relative" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "w-full my-[10px] px-[10px] flex justify-center relative items-center" }
const _hoisted_16 = { class: "flex w-full relative" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "A_recherche",
  class: "absolute cursor-pointer p-[10px] top-0 right-0 text-cyan-600"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-search" })
], -1)
const _hoisted_18 = { class: "container max-w-[1024px]" }
const _hoisted_19 = { class: "text-2xl px-4 font-bold text-center my-[20px]" }
const _hoisted_20 = { class: "flex flex-wrap justify-center items-center w-full" }
const _hoisted_21 = { class: "flex justify-center items-center my-8 space-x-4" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  disabled: true,
  class: "bg-gray-200 text-gray-700 font-bold py-2 px-4 rounded cursor-pointer"
}
const _hoisted_24 = ["disabled"]

import One_article from '../components/One_article.vue';
import HeaderComponent from '../components/HeaderComponent.vue'
import carouselBranding from '../components/CarouselBranding.vue'
import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import FooterComponent from '@/components/FooterComponent.vue';
import axios from 'axios'
import axiosInstance from '@/plugins/axios';

const initialSlide = 3;
const pageSize = 6; 

export default /*#__PURE__*/_defineComponent({
  __name: 'Articles',
  setup(__props) {

const pageTitle = ref('IronSecur | Articles'); 
const email = ref('');
const loading = ref(false);
const successMessage = ref('');
const errorMessage = ref('');

const articles = ref<any[]>([]);
const filteredArticles = ref<any[]>([]);



const subscribe = () => {
  loading.value = true;

  axiosInstance.post('/subscribers/', { email: email.value })
    .then(response => {
      loading.value = false;

      if (response.status === 200 || response.status === 201 || response.status === 204) {
        successMessage.value = 'Email envoyé avec succès !';
        hideSuccessMessageAfterDelay();
        email.value= '';
      } else {
        successMessage.value = '';
      }
    })
    .catch(error => {
      loading.value = false;
      console.error(error);
      if (error.response && error.response.status === 400 && error.response.data && error.response.data.email && error.response.data.email[0] === 'This email adress has already used') {
          successMessage.value = 'Cet email est déjà enregistré.';
          hideSuccessMessageAfterDelay();
          email.value = '';
      } else {
          errorMessage.value = 'Une erreur s\'est produite. Veuillez réessayer.';
          hideErrorMessageAfterDelay();
      }
  });
};

const hideSuccessMessageAfterDelay = () => {
  setTimeout(() => {
    successMessage.value = ''; 
  }, 5000);
};

const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 5000);
};


onMounted(() => {
    document.title = pageTitle.value; 
});



// ... (votre code existant)

const fetchAllArticles = async () => {
    try {
        let allArticles: any[] = [];
        let nextPage = '/articles/';

        while (nextPage) {
            const response = await axiosInstance.get(nextPage);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                const { results, next } = response.data;
                allArticles = allArticles.concat(results);
                nextPage = next;
            } else {
                nextPage = null;
            }
        }

        return allArticles;
    } catch (error) {
        console.error('Erreur lors du chargement des articles', error);
        return [];
    }
};

const handleSearch = async (event: any) => {
    const searchTerm = event.target.value.toLowerCase().trim();

    if (!searchTerm) {
        filteredArticles.value = articles.value;
    } else {
        const allArticles = await fetchAllArticles();

        if (allArticles.length > 0) {
            filteredArticles.value = allArticles.filter(article => {
                return (
                    (article.title && article.title.toLowerCase().includes(searchTerm)) ||
                    (article.content && article.content.toLowerCase().includes(searchTerm))
                );
            });
        }
    }
};


 

onMounted(async () => {
  document.title = pageTitle.value;
  await fetchArticles(); 
  try {
    const response = await axiosInstance.get('/articles/');
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const fetchedArticles = response.data.results;
      // Sort fetched articles by date if needed
      fetchedArticles.sort((a: any, b: any) => {
        return new Date(b.date).getTime() - new Date(a.date).getTime();
      });
      articles.value = fetchedArticles;
      filteredArticles.value = fetchedArticles;
    }
  } catch (error) {
    console.error('Erreur lors du chargement des articles', error);
  }
});

const currentPage = ref(1);
const hasPreviousPage = ref(false);
const hasNextPage = ref(false);

const loadArticles = async (page: number) => {
  try {
    const response = await axiosInstance.get(`/articles/?page=${page}&page_size=${pageSize}`);

    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const { results, previous, next } = response.data;
      results.sort((a: any, b: any) => {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
      });
      filteredArticles.value = results;
      hasPreviousPage.value = !!previous;
      hasNextPage.value = !!next;
    }
  } catch (error) {
    console.error('Erreur lors du chargement des articles', error);
  }
};


const loadPreviousPage = () => {
  if (hasPreviousPage.value) {
    currentPage.value--;
    loadArticles(currentPage.value);
  }
};

const loadNextPage = () => {
  if (hasNextPage.value) {
    currentPage.value++;
    loadArticles(currentPage.value);
  }
};

onMounted(() => {
  loadArticles(currentPage.value);
});

const fetchArticles = async () => {
    try {
        const response = await axiosInstance.get('/articles/');
        if (response.status === 200 || response.status === 201 || response.status === 204) {
            const fetchedArticles = response.data.results;
            
            // Filtrer les articles avec is_published à true
            const publishedArticles = fetchedArticles.filter(article => article.is_published);

            // Trier les articles par date
            publishedArticles.sort((a, b) => new Date(b.date) - new Date(a.date));

            articles.value = publishedArticles;
            filteredArticles.value = publishedArticles;
        }
    } catch (error) {
        console.error('Erreur lors du chargement des articles', error);
    }
};


const totalPageCount = ref(0);

const fetchTotalPageCount = async () => {
  try {
    const response = await axiosInstance.get('/articles/');
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const totalArticles = response.data.count;
      totalPageCount.value = Math.ceil(totalArticles / pageSize);
    }
  } catch (error) {
    console.error('Erreur lors du chargement du nombre total de pages', error);
  }
};

onMounted(() => {
  fetchTotalPageCount();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent),
    (successMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(successMessage.value), 1))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(carouselBranding, { "initial-slide": initialSlide }),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("form", {
          onSubmit: _withModifiers(subscribe, ["prevent"]),
          class: "flex relative max-w-full items-center justify-center"
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('atitre1')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('atitre2')), 1)
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              required: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              class: "md:w-[400px] w-full text-black border border-gray-600 md:p-[10px] p-[5px] bg-white outline-none",
              placeholder: "Entrer votre Email"
            }, null, 512), [
              [_vModelText, email.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "submit",
              disabled: loading.value,
              class: "border min-w-[100px] border-white bg-cyan-500 text-white md:p-[10px] p-[5px] rounded-[5px] md:ml-[10px] ml-[5px]"
            }, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('subscribe')), 1))
            ], 8, _hoisted_12)
          ])
        ], 40, _hoisted_8)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("input", {
          type: "text",
          id: "A_recherche",
          class: "w-full p-[10px] border border-gray-500 outline-none focus:border-cyan-600",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (handleSearch($event))),
          placeholder: "Filtrer à partir du nom"
        }, null, 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_19, _toDisplayString(_ctx.$t('everyday')), 1),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(One_article, { articles: filteredArticles.value }, null, 8, ["articles"])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          onClick: loadPreviousPage,
          disabled: !hasPreviousPage.value,
          class: _normalizeClass({ 'bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded': hasPreviousPage.value, 'bg-gray-300 text-gray-500 cursor-not-allowed py-2 px-4 rounded': !hasPreviousPage.value })
        }, " Previous ", 10, _hoisted_22),
        _createElementVNode("button", _hoisted_23, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPageCount.value), 1),
        _createElementVNode("button", {
          onClick: loadNextPage,
          disabled: !hasNextPage.value,
          class: _normalizeClass({ 'bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded': hasNextPage.value, 'bg-gray-300 text-gray-500 cursor-not-allowed py-2 px-4 rounded': !hasNextPage.value })
        }, " Next ", 10, _hoisted_24)
      ])
    ]),
    _createVNode(FooterComponent)
  ]))
}
}

})